export default __webpack_public_path__ + "static/media/orange-marker.e912e43d.svg";